import React, { useState } from "react";
import { ReactComponent as Clock } from "../../assets/clock.svg";
import { ReactComponent as RightArrow } from "../../assets/rightArrow.svg";
import { ReactComponent as Instructor } from "../../assets/instructor.svg";
import { API } from "../../backend";
import { CourseT } from "../../types/model";
import "./CourseCard.css";
import { getHttpHandler } from "../../utils/httpHandler";
import { isAuthenticated } from "../../auth/helper/auth";

const CourseCard: React.FC<{
  course: CourseT;
  setCourses: React.Dispatch<React.SetStateAction<CourseT[]>>;
  setAuthShow: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ course, setCourses, setAuthShow }) => {
  const [enrolling, setEnrolling] = useState<boolean>(false);

  const enrollCourses = async () => {
    if (!isAuthenticated()) {
      setAuthShow(true);
      return;
    }
    setEnrolling(true);
    try {
      await getHttpHandler({
        url: `${API}/enroll/${course?._id}/${isAuthenticated()?.user._id}`,
        idToken: isAuthenticated()?.token,
      });
      setCourses((oldCourses) => {
        let oCourses = [...oldCourses];
        let nCourses = oCourses.map((c) => {
          if (c._id === course?._id) {
            c.enrolledUsers.push(isAuthenticated()?.user._id);
          }
          return c;
        });
        return nCourses;
      });
      setEnrolling(false);
    } catch (errorResp: any) {
      setEnrolling(false);
      console.log(errorResp);
    }
  };

  return (
    <div className="course-card" key={course?._id}>
      <div className="course-data">
        <img
          src={`${API}/course/thumbnail/${course?._id}`}
          alt="course thumbnail"
          className="thumbnail"
        />
        <div className="course-content">
          <h2 className="name">{course?.name}</h2>
          {/* <p className="description">
            {course?.description.slice(0, 100)}
            ...
          </p> */}
        </div>
      </div>
      <div className="bottom-div">
        {/* <div className="instructor">
          <Instructor /> <span>{course?.instructorName}</span>
        </div>
        <div className="date">
          <Clock />
          <span>Start:</span> {new Date(course?.startDate).toDateString()}
        </div>
        <div className="date">
          <Clock />
          <span>Finish:</span> {new Date(course?.endDate).toDateString()}
        </div> */}
        <h3>
          Price: <span>₹{course?.price}</span>
        </h3>
        <button
          onClick={(e) => {
            e.preventDefault();
            if (
              !course?.enrolledUsers.includes(
                isAuthenticated()?.user?._id ?? ""
              )
            ) {
              enrollCourses();
            }
          }}
        >
          {course?.enrolledUsers.includes(
            isAuthenticated()?.user?._id ?? ""
          ) ? (
            "ENROLLED"
          ) : (
            <>
              {enrolling ? "Enrolling..." : "Enroll"} <RightArrow />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default CourseCard;
